import { useState } from 'react';
import { Button } from '@mui/joy';
import AddIcon from '@mui/icons-material/Add';
import { AddCategoryForm } from './AddCategoryForm';

export function AddCategory({ onCategoryCreated }) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleSave = (categoryData) => {
    setIsFormOpen(false);
    onCategoryCreated(categoryData);
  };

  const handleCancel = () => {
    setIsFormOpen(false);
  };

  if (isFormOpen) {
    return (
      <AddCategoryForm
        onSave={handleSave}
        onCancel={handleCancel}
      />
    );
  }

  return (
    <Button
      startDecorator={<AddIcon />}
      onClick={() => setIsFormOpen(true)}
      sx={{ width: { xs: '100%', sm: 'auto' } }}
    >
      Add Category
    </Button>
  );
}

